<template>
	<v-container class="d-flex flex-column align-start" pa-0 fluid fill-height>
		<FullHeader />
		<v-container fluid style="display:flex; flex-grow: 1;max-height: 100%;height: 200px;" class="pa-0">
			<v-container fluid class="pa-3 d-flex flex-column" style="gap: 8px;">

				<!-- Toolbar -->
				<div class="docs-toolbar">
					<div class="docs-toolbar__stats">
						<span class="stat-chip">
							<v-icon size="14" color="#2D4B95">mdi-folder-multiple-outline</v-icon>
							<strong>{{ folderCount }}</strong> especialidades
						</span>
						<span class="stat-chip">
							<v-icon size="14" color="#2D4B95">mdi-file-document-multiple-outline</v-icon>
							<strong>{{ documentCount }}</strong> documentos
						</span>
					</div>
					<div class="docs-toolbar__actions">
						<v-btn
							small depressed
							:loading="loading"
							:disabled="loading"
							color="#e8ecf5"
							class="toolbar-btn"
							@click="getDocuments"
						>
							<v-icon size="16" color="#2D4B95" left>mdi-refresh</v-icon>
							<span style="color:#2D4B95">Recargar</span>
						</v-btn>
						<v-btn
							small depressed
							:disabled="loading || tableData.folders.length === 0"
							color="#2D4B95"
							class="toolbar-btn"
							@click="exportDocuments"
						>
							<v-icon size="16" color="white" left>mdi-file-export-outline</v-icon>
							<span style="color:white">Exportar</span>
						</v-btn>
					</div>
				</div>

				<!-- Loading -->
				<v-row v-if="loading" justify="center" align="center" style="height:200px;">
					<v-progress-circular indeterminate color="indigo darken-4" size="48" />
				</v-row>

				<!-- Table -->
				<documents-revision-table
					v-else-if="tableData.folders.length > 0"
					:data="tableData"
					@revision-updated="onRevisionUpdated"
				/>
			</v-container>
		</v-container>
	</v-container>
</template>

<script>
import EventBus from '@/helpers/event_bus'
import FullHeader from '../../Globals/Headers/FullHeader'
import DocumentsRevisionTable from './DocumentsRevisionTable.vue'
import { getDocumentsListing } from '@/helpers/api/documents'
import { exportDocumentsListing } from '@/helpers/api/exports'

export default {
	name: 'DocumentsRevisionTablePage',
	components: { FullHeader, DocumentsRevisionTable },
	computed: {
		selectedProject() {
			return this.$store.projectsStore.state.selectedProject
		},
		folderCount() {
			return this.tableData.folders.filter(f =>
				!f.name.toLowerCase().includes('obsoleto')
			).length
		},
		documentCount() {
			return this.tableData.folders
				.filter(f => !f.name.toLowerCase().includes('obsoleto'))
				.reduce((total, folder) => {
					const directFiles = (folder.files || []).length
					const childFiles = (folder.childs || [])
						.filter(c => !c.name.toLowerCase().includes('obsoleto'))
						.reduce((s, c) => s + (c.files || []).length, 0)
					return total + directFiles + childFiles
				}, 0)
		}
	},
	beforeUnmount() {
		EventBus.$off('completedFileUpload')
	},
	watch: {
		selectedProject(newData, oldData) {
			if (newData && newData.id !== oldData?.id) {
				this.getDocuments()
			}
		}
	},
	data() {
		return {
			loading: false,
			exporting: false,
			tableData: { folders: [] }
		}
	},
	mounted() {
		if (this.selectedProject) {
			this.getDocuments()
		}
		this.setFileListeners()
	},
	methods: {
    setFileListeners(){
      EventBus.$on('completedFileUpload', async (payload) => {
        if(payload && (payload.main_file_revision_id || payload.last_revision_file_id)){
					this.getDocuments()
        }
      })
    },
		async getDocuments() {
			this.loading = true
			try {
				const documents = await getDocumentsListing({ project_id: this.selectedProject.id })
				if (documents && documents.code === 200) {
					this.tableData.folders = documents.folders
				}
			} finally {
				this.loading = false
			}
		},
		async exportDocuments() {
			this.exporting = true
			try {
				const exportDocuments = await exportDocumentsListing({ project_id: this.selectedProject.id })
				if (exportDocuments.code == 200) {
					window.open(exportDocuments.url);
				}
			} finally {
				this.exporting = false
			}
		},
		onRevisionUpdated({ file, revIndex, field, value }) {
			console.log('Updated:', file.name, revIndex, field, value)
		}
	}
}
</script>

<style scoped>
.docs-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #ffffff;
	border: 1px solid #e0e0e0;
	border-radius: 4px;
	padding: 8px 12px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.08);
	flex-shrink: 0;
}

.docs-toolbar__stats {
	display: flex;
	align-items: center;
	gap: 12px;
}

.stat-chip {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	background: #f4f6fb;
	border: 1px solid #e8ecf5;
	border-radius: 20px;
	padding: 4px 12px;
	font-size: 12px;
	color: #576080;
}

.stat-chip strong {
	color: #2D4B95;
	font-weight: 600;
}

.docs-toolbar__actions {
	display: flex;
	align-items: center;
	gap: 8px;
}

.toolbar-btn {
	text-transform: none !important;
	letter-spacing: 0 !important;
	font-size: 13px !important;
	border-radius: 6px !important;
}
</style>